import { cn } from "@babybjorn/ui";
import { forwardRef, type PropsWithChildren } from "react";
import ModalOverlay from "../Modal/components/ModalOverlay/ModalOverlay";
import * as s from "./Header.module.scss";

type HeaderProps = PropsWithChildren<{
	isOpen: boolean;
	onCloseNav: () => void;
}>;

const Header = forwardRef<HTMLElement, HeaderProps>(
	({ children, isOpen, onCloseNav }, ref) => (
		<>
			<header ref={ref} className={cn(s.header, { [s.isOpen]: isOpen })}>
				{children}
			</header>
			{isOpen && <ModalOverlay onClick={onCloseNav} />}
		</>
	),
);

Header.displayName = "Header";

export default Header;
